import { Suspense } from 'react';
import * as React from 'react';
import { Link } from 'react-router-dom';

import TextButton from '@/components/elements/Button/TextButton';
import SkeletonContentBody from '@/components/layouts/News/ContentBody/Skeleton';
import NewsTypeSelector from '@/components/layouts/News/NewsTypeSelector';
import { Blog, Campaign, News } from '@/lib/microcms/model';
import { getNewsTypeName } from '@/lib/news';
import { Content, NewsType } from '@/pages/News/types';

import { BackLinkWrapper, Container, ContentWrapper } from './style';

const NewsContent = React.lazy(
  () => import('@/components/layouts/News/ContentBody/News'),
);
const CampaignContent = React.lazy(
  () => import('@/components/layouts/News/ContentBody/Campaign'),
);
const BlogContent = React.lazy(
  () => import('@/components/layouts/News/ContentBody/Blog'),
);

interface NewsContentTemplateProps {
  content: Content | null;
  newsType: NewsType;
  isEnteredEntryCampaign?: boolean;
  nextContent: Blog | null;
  prevContent: Blog | null;
}

const NewsTemplate: React.FC<NewsContentTemplateProps> = ({
  content,
  newsType,
  isEnteredEntryCampaign,
  nextContent,
  prevContent,
}) => {
  return (
    <Container>
      <NewsTypeSelector newsType={newsType} />
      <ContentWrapper>
        {content ? (
          <Suspense fallback={<></>}>
            {newsType === NewsType.Blog && (
              <BlogContent
                content={content as Blog}
                nextContent={nextContent}
                prevContent={prevContent}
              />
            )}
            {newsType === NewsType.Campaign && (
              <CampaignContent
                content={content as Campaign}
                isEnteredEntryCampaign={Boolean(isEnteredEntryCampaign)}
              />
            )}
            {newsType === NewsType.News && (
              <NewsContent content={content as News} />
            )}
          </Suspense>
        ) : (
          <SkeletonContentBody newsType={newsType} />
        )}
      </ContentWrapper>
      <BackLinkWrapper>
        <Link to={`/${newsType}`}>
          <TextButton size="s" hoverEffect="highlight">
            {getNewsTypeName(newsType)}一覧に戻る
          </TextButton>
        </Link>
      </BackLinkWrapper>
    </Container>
  );
};

export default NewsTemplate;
